export class CustomFile {
    name!: string;
    file!: File;
    value!: any;
    object!: any;
}